<div class="modal-header">
  <h5 class="card-title" i18n>Cancel order</h5>
  <button type="button" class="btn-close" (click)="activeModal.close()"></button>
</div>

<div class="modal-body">
  <p i18n>You can cancel the order free of charge up to 24 hours before the scheduled start time.</p>
  <p i18n>If you cancel less than 24 hours before the scheduled start time, a cancellation fee of 50% of the total price will apply.</p>
  <p i18n>Are you sure you want to cancel this order?</p>
  <textarea class="form-control" rows="5" placeholder="Reason for cancelling" i18n-placeholder [(ngModel)]="cancel_reason"></textarea>
</div>
<div class="modal-footer text-end">
  <button type="button" [disabled]="!cancel_reason" class="btn btn-danger" (click)="cancel()" i18n>Cancel order</button>
  <button type="button" class="btn btn-secondary" (click)="activeModal.close()" i18n>Close</button>
</div>